import Icon from "@ant-design/icons"
import { ReactComponent as ChinaFlag } from "./china.svg"

const ChinaFlagIcon = (props: any) => <Icon component={ChinaFlag} {...props} />

export default ChinaFlagIcon
